import "./index.css";
import React, { forwardRef } from "react";
import { colorMapping } from "./constants";

export default forwardRef(function TagDropdown(
  { tag, tagOptions, onTagChange, isOpen },
  ref
) {
  return (
    <ul className="tag-dropdown" ref={ref}>
      {isOpen &&
        tagOptions &&
        tagOptions.map((option, i) => (
          <li
            className={`tag-dropdown__list-item ${
              (i === 0 && !tag) || tag === option.value
                ? "tag-dropdown__list-item--selected"
                : ""
            } ${i === 0 ? "tag-dropdown__list-item-default" : ""}`}
            onClick={() => onTagChange(option)}
            key={i}
          >
            <div
              className="tag-dropdown__circle"
              style={{
                backgroundColor: colorMapping[option.value]
                  ? colorMapping[option.value]
                  : "#dcdcdc",
              }}
            />
            <span>{option.label}</span>
          </li>
        ))}
    </ul>
  );
});



// WEBPACK FOOTER //
// ./src/components/UploadPanel/components/TagDropdown/index.js